import { useMutationApi, useQueryApi } from 'utils/api'

import type { CustomError } from 'utils/customError'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'
import type {
  ParamsApiGetPelaksanaanList,
  ResponseApiGetPelaksanaanList,
  ResponseApiGetRencanaTindakLanjut,
  ResponseApiGetSchoolList,
  ParamsApiGetRencanaTindakLanjut,
  ParamsUpsertRencanaTindakLanjut,
  ParamsApiGetPemantauanRencanaTindakLanjut,
  ResponseApiGetPemantauanRencanaTindakLanjut,
  ParamsUpsertPemantauanRencanaTindakLanjut,
} from 'types/kinerja-gpk'

const BASE_PATH = '/guru/skp'

// -------------------------------------
// Get Pelaksanaan School List for GPK
// -------------------------------------
export const API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY =
  'API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY'

export function useApiGetPelaksanaanSchoolList({
  options,
}: {
  options?: UseQueryOptions<ResponseApiGetSchoolList>
}) {
  const queryKey = [API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY]

  return useQueryApi<ResponseApiGetSchoolList>(`${BASE_PATH}/v1/gpk/schools`, {
    queryConfig: {
      ...options,
    },
    queryKey,
  })
}

// -------------------------------------
// Get Pelaksanaan list
// -------------------------------------
export const API_GET_PELAKSANAAN_LIST_QUERY_KEY =
  'API_GET_PELAKSANAAN_LIST_QUERY_KEY'

export function useApiGetPelaksanaanList({
  params,
  options,
}: {
  params: ParamsApiGetPelaksanaanList
  options?: UseQueryOptions<ResponseApiGetPelaksanaanList>
}) {
  const queryKey = [
    API_GET_PELAKSANAAN_LIST_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetPelaksanaanList>(
    `${BASE_PATH}/v1/gpk/pelaksanaan/list-guru/states`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          skpYear: params.skpYear,
          skpPeriod: params.skpPeriod,
        },
      },
      queryKey,
    }
  )
}

// -------------------------------------
// Get Rencana Tindak Lanjut data
// -------------------------------------
export const API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY =
  'API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY'

export function useApiGetRencanaTindakLanjut({
  params,
  options,
}: {
  params: ParamsApiGetRencanaTindakLanjut
  options?: UseQueryOptions<ResponseApiGetRencanaTindakLanjut>
}) {
  const queryKey = [
    API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetRencanaTindakLanjut>(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          tipe: 'GPK',
          ...params,
        },
      },
      queryKey,
    }
  )
}

// -------------------------------------
// Upsert Rencana Tindak Lanjut
// -------------------------------------
export function useApiUpsertRencanaTindakLanjut(
  options?: UseMutationOptions<
    unknown,
    CustomError,
    ParamsUpsertRencanaTindakLanjut
  >
) {
  return useMutationApi(`${BASE_PATH}/v1/pelaksanaan/document-follow-up`, {
    axiosConfig: {
      method: 'POST',
    },
    mutationConfig: options,
  })
}

// -------------------------------------
// Get Pemantauan Rencana Tindak Lanjut data
// -------------------------------------
export const API_GET_PEMANTAUAN_RENCANA_TINDAK_LANJUT_QUERY_KEY =
  'API_GET_PEMANTAUAN_RENCANA_TINDAK_LANJUT_QUERY_KEY'

export function useApiGetPemantauanRencanaTindakLanjut({
  params,
  options,
}: {
  params: ParamsApiGetPemantauanRencanaTindakLanjut
  options?: UseQueryOptions<ResponseApiGetPemantauanRencanaTindakLanjut>
}) {
  const queryKey = [
    API_GET_PEMANTAUAN_RENCANA_TINDAK_LANJUT_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetPemantauanRencanaTindakLanjut>(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up-evaluation`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          tipe: 'GPK',
          ...params,
        },
      },
      queryKey,
    }
  )
}

// -------------------------------------
// Upsert Pemantauan Rencana Tindak Lanjut
// -------------------------------------
export function useApiUpsertPemantauanRencanaTindakLanjut(
  ptkId: string,
  options?: UseMutationOptions<
    unknown,
    CustomError,
    ParamsUpsertPemantauanRencanaTindakLanjut
  >
) {
  return useMutationApi(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up-evaluation/${ptkId}`,
    {
      axiosConfig: {
        method: 'POST',
      },
      mutationConfig: options,
    }
  )
}
